import EfIcon from '@elem/ui/ef-icon';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.OtherC');
    return (
        <div className={`ef-container ${styles.TheComp}`}>
            <div className="OtherC-list-title title-1">{t('list_a_title')}</div>
            <div className="OtherC-list compb">
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725589963898/CES2024.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725590105344/MUO.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725589964654/IF.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725590105573/red%20dot.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725589964431/cnn%20underscored.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725590106218/TIME%20Best%20Inventions.png" />
            </div>
        </div>
    );
}
